import React, {useState, useEffect} from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import { Helmet } from 'react-helmet-async';
import { Link as RouterLink, useLocation, useNavigate } from 'react-router-dom';
import { Grid, Container, Typography, Button, Box, FormControl, Input, InputAdornment, Skeleton, Paper, ButtonGroup} from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { Property } from '../sections/@dashboard/home';
import { useUserViewPropertyQuery, useUserNetworkMutation, useUserProfileQuery } from '../services/dvagent'
import { PropertyCard } from '../components/skeleton';
import { getToken, getUsername, storeAdmin } from '../services/LocalStorageService';
import Iconify from '../components/iconify';
import { Toaster } from '../sections/@dashboard/attributes';
import { Unauthorized } from '../sections/@dashboard/manageUser';
import serverUrl from '../_mock/account'

export default function Home() {
  const [loading, setLoading] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const [properties, setProperties] = useState([]);
  const [networkData, setNetworkData] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [view, setView] = useState('grid');
  const { data, isSuccess, error } = useUserViewPropertyQuery({"token":getToken(), "location":location});
  const { data:userData, isSuccess:userIsSuccess } = useUserProfileQuery(getToken());
  const [userNetwork] = useUserNetworkMutation();
  const [open, setOpen] = React.useState(false);
  const paginationModel = { page: 0, pageSize: 10 };
  const baseUrl = serverUrl.serverUrl; 
  const [toasterData, setToasterData] = useState({
    trigger: false,
    status: true,
    symbol: '✔',
    message: '',
  });

  const handleClose = () => setOpen(false);

  const columns = [
    { field: 'serialNumber', headerName: 'S. No.', },
    {
      field: 'name',
      headerName: 'Name',
      flex: 1,
      renderCell: (params) => (
        <button
          style={{
            background: 'none',
            border: 'none',
            color: '#000',
            fontWeight: 'bold',
            textDecoration: 'none',
            cursor: 'pointer',
          }}
          onClick={() => handleUserNetwork(params.row.id)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') handleUserNetwork(params.row.id);
          }}
          type="button"
        >
          {params.row.name}
        </button>
      ),
    },
    { field: 'location', headerName: 'Location', flex: 1 },
  ];

  if(userData && userIsSuccess) {
    storeAdmin((userData.data[0].is_superuser).toString());
  }

  useEffect(() => {
    if (error) {
      if (error.status === 401) {
        // showToast(false, 'ⓘ', 'Unauthorized User');
      } else {
        showToast(false, 'ⓘ', 'Something went wrong, server error');
      }
    }
    if (data && isSuccess) {
      setProperties(data.properties)
    }
    setTimeout(() => {
      setLoading(true);
    }, 1000);
  }, [data, isSuccess, error, navigate]);  


  const handleUserNetwork = async (propertyId) => {
    const actualData = {
      id: propertyId,
      token: getToken()
    }
    const res = await userNetwork(actualData);
    if (res.error) {
      if (res.error.status===400) {
        showToast(false, 'ⓘ', 'Something went wrong, bad request');
      } else if (res.error.status===401) {
        showToast(false, 'ⓘ', 'Access Denied');
      } else if (res.error.status===500) {
        showToast(false, 'ⓘ', 'Something went wrong, server error');
      } else {
        showToast(false, 'ⓘ', 'Something went wrong, please try again');
      }
    }
    if (res.data) {
      setNetworkData(res.data.network)
      if(res.data.network.length===1){
        navigate('/cloud/devices', { state: res.data.network[0] });
      }
      setOpen(true)
    }
  };

  const handleSearch = (event) => {
    setSearchQuery(event.target.value);
  };

  const filteredProperty = properties.filter(
    (item) =>
      item.name
        .toLowerCase()
        .includes(searchQuery.toLowerCase())
  );

  const rows = filteredProperty.map((row, index) => ({
    ...row,
    serialNumber: index + 1,
  }));

  const handleViewChange = (newView) => {
    setView(newView);
  };

  const showToast = (status, symbol, message) => {
    setToasterData({
      trigger: true,
      status,
      symbol,
      message,
    });

    setTimeout(() => {
      setToasterData((prev) => ({
        ...prev,
        trigger: false,
      }));
    }, 5000); 
  };
  return (
    <>
      <Helmet>
        <title> DV Agent </title>
      </Helmet>

      {toasterData.trigger && (
        <Toaster
          trigger={toasterData.trigger}
          status={toasterData.status}
          symbol={toasterData.symbol}
          message={toasterData.message}
        />
      )}
      <Container maxWidth="xxl">
        <div>
          <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            >
            <DialogContent>
              <Typography sx={{textAlign:"center", fontWeight: 'bold', paddingBottom: 1.5, fontSize: 18}}>
                Select Network
              </Typography>
            </DialogContent>
            <Box
              noValidate
              component="form"
              sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  m: 'auto',
                  width: 'fit-content',
              }}>
              {networkData.map((item) =>
                <Button
                  key={item.network_name}
                  to="/cloud/devices"
                  state={item}
                  component={RouterLink}
                  fullWidth
                  size="large"
                  sx={{
                    color: '#FFF',
                    border: 1,
                    borderColor: '#A8A196',
                    bgcolor: '#A8A196',
                    marginBottom: 2,
                    marginX:2,
                    width: '260px',
                    ":hover": {
                        bgcolor: "#7D7463", 
                        borderColor: '#7D7463',
                    }}}>              
                  {item.network_name}
                </Button>
              )}
              </Box>
          </Dialog>
        </div>
               
        {loading ? (
          <> 
          <Grid container spacing={3} sx={{mb : 2}} alignItems="center">
            <Grid item xs={12} sm={4} md={4} lg={6}>
              <Typography variant="h6" color="text.secondary">
                Hi {loading ? getUsername() : <></>}
              </Typography>
            </Grid>
            <Grid item xs={12} sm={8} md={8} lg={6}>
              <FormControl
                variant="standard"
                fullWidth
              >
                <Input
                  id="standard-adornment-amount"
                  variant="standard"
                  value={searchQuery}
                  onChange={handleSearch}
                  placeholder="Search"
                  startAdornment={
                    <InputAdornment position="start">
                      <Iconify icon="eva:search-fill" />
                    </InputAdornment>
                  }
                />
              </FormControl>
            </Grid>
          </Grid>

          <ButtonGroup
            variant="outlined"
            aria-label="Disabled button group"
            sx={{ mb: 2 }}
          >
            <Button
              onClick={() => handleViewChange('grid')}
              variant={view === 'grid' ? 'contained' : 'outlined'}
            >
              <Iconify icon="line-md:grid-3-filled" />
              &nbsp;Grid
            </Button>
            <Button
              onClick={() => handleViewChange('list')}
              variant={view === 'list' ? 'contained' : 'outlined'}
            >
              <Iconify icon="line-md:list-3-filled" />
              &nbsp;List
            </Button> 
          </ButtonGroup>

            {properties.length === 0 && (
              <Unauthorized/>
            )}
            {view === 'grid' ? (
                <Grid container spacing={3}>
                  {filteredProperty.map((item) =>
                    <Grid item xs={12} sm={6} md={4} xl={3} onClick={() => handleUserNetwork(item.id)} key={item.name}>
                      <Property thumbnail={baseUrl + item.thumbnail} name={item.name} location={item.location} />
                    </Grid>
                  )}
                </Grid>
              ): (
                <Paper>
                  <DataGrid
                    rows={rows}
                    columns={columns}
                    initialState={{ pagination: { paginationModel } }}
                    pageSizeOptions={[10, 25, 50, 100]}
                    checkboxSelection
                    sx={{
                      border: 0,
                      '& .MuiDataGrid-columnHeaders': {
                        backgroundColor: '#afb3c7', 
                        color: '#A8A196',          
                        fontSize: '16px',          
                        fontWeight: 'bold',        
                      },
                      '& .MuiDataGrid-columnSeparator': {
                        display: 'none',           
                      },
                    }}
                  />
                </Paper>
              )}
          </>
        ):(
          <>
            <Grid container spacing={3} alignItems="center">
              <Grid item xs={12} sm={4} md={4} lg={6}>
                <Typography variant="h6" color="text.secondary">
                  <Skeleton animation="wave" height={40} width="30%" />
                </Typography>
              </Grid>
              <Grid item xs={12} sm={8} md={8} lg={6}>
                <FormControl
                  variant="standard"
                  fullWidth
                >
                  <Input
                    id="standard-adornment-amount"
                    variant="standard"
                    value={searchQuery}
                    onChange={handleSearch}
                    placeholder="Search"
                    startAdornment={
                      <InputAdornment position="start">
                        <Iconify icon="eva:search-fill" />
                      </InputAdornment>
                    }
                  />
                </FormControl>
              </Grid>
            </Grid>
            <Grid container spacing={3} alignItems="center">
              <Grid item xs={12} sm={4} md={4} lg={6}>
                <Typography variant="h6" color="text.secondary">
                  <Skeleton animation="wave" height={60} width="25%" />
                </Typography>
              </Grid>
            </Grid>
            <Grid container spacing={3}>
              {Array.from({ length: 20 }).map((_, index) => (
                <Grid item xs={12} sm={6} md={4} xl={3} key={index}>
                  <PropertyCard/>
                </Grid>
              ))}
            </Grid>
          </>
        )}
      </Container> 
    </>
  );
}

